import { useUser } from "./useUser";
import { NavLink } from "react-router-dom";
import AdminLineItem from "@/components/AdminLineItem";
import typo from "@/styles/Typography.module.css";

export default function SurveyOverview() {
  const user = useUser();
  console.log("SurveyOverview user:", user);

  return (
    <div style={{zIndex: "1000"}}>
     <AdminLineItem>
          <div className="mb-4">
            <h1 style={{color: "#F16D09", paddingBottom: "2.5rem", marginTop: "3rem"}}>Survey Management</h1>
          </div>
      <div>
      {/* Survey management tools */}
             <div className="row g-1">
      <div>
          <div style={{ paddingTop: ".5rem", marginTop: "2rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
              SURVEY MANAGEMENT TOOLS
            </p>
          </div>
        </div>
              <div>
                <div className={typo.cardWhite_narrow} style={{ paddingTop: "1rem"}}>
                  <NavLink
            to="/admin/surveyMaker/builder"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "black", textAlign: "left" }}
          >
            Survey Builder - start from scratch and build your survey ready to send or copy and edit a previous survey.
          </NavLink>
                </div>
              </div>
              <div>
                <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
                  <NavLink
            to="/admin/surveyMaker/manage"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "black", textAlign: "left" }}
          >
            Survey Manager - create a copy or a new instance of an already published survey
          </NavLink>
                </div>
                 <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
                  <NavLink
            to="/admin/monitoring/SurveyMonitor"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "black", textAlign: "left" }}
          >
            Survey Monitor - survey tracking dashboard: monitor survey progress, close surveys when needed, search for surveys by tags.
          </NavLink>
                </div>
              </div>
              </div>
              </div>
    </AdminLineItem>
    </div>
  );
}
